var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOffIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2a6 6 0 110 12H12a7.488 7.488 0 003-6 7.488 7.488 0 00-3-6h4.5zm-9 12a6 6 0 110-12 6 6 0 010 12zM0 8a7.5 7.5 0 007.5 7.5h9a7.5 7.5 0 000-15h-9A7.5 7.5 0 000 8z"
  })));
}
export default SvgToggleOffIcon;